import {
    IEmailRequest,
    IEmailRequestAbrindoCaso,
    IEnviarEmail,
    IGerarPDF,
    IInserirEnvelope,
    ITriagem,
} from "../../../Interfaces/Geral/Email/EmailInterface";
import {
    BuscarInformacoesEnvelopeService,
    DesvincularContratosCasoService,
    DownloadEnvelopeService,
    EnviarEmailAnexoAbrindoCasoService,
    EnviarEmailAnexoService,
    EnviarEmailService,
    ExportarDocumentoHtmlParaPdfServices,
    GerarDocumentosTemplateServices,
    InserirEnvelopeDocusignService,
    ListarClienteEmailTriagemService,
    ListarClienteRespostaEmailTriagemService,
    ListarContratosCasoServices,
    ListarEnvelopesCasoService,
    ReenviarEnvelopeService,
    ResponderEmailAnexoService,
} from "../../../Services/Geral/Email/EmailService";
import { Controller } from "../../Controller";

export async function EnviarEmailController(requestBody: IEnviarEmail) {
    return Controller(EnviarEmailService(requestBody));
}

export async function EnviarEmailAnexoController(requestBody: IEmailRequest) {
    return Controller(EnviarEmailAnexoService(requestBody));
}

export async function EnviarEmailAnexoAbrindoCasoController(
    requestBody: IEmailRequestAbrindoCaso,
    ID_CONTA: number,
    idTipoCaso: number
) {
    return Controller(
        EnviarEmailAnexoAbrindoCasoService(requestBody, ID_CONTA, idTipoCaso)
    );
}

export async function ResponderEmailAnexoController(
    id_email: number,
    requestBody: IEmailRequest
) {
    return Controller(ResponderEmailAnexoService(id_email, requestBody));
}

export async function ExportarDocumentoHtmlParaPdfController(
    requestBody: IGerarPDF,
    FL_GERAR_PDF?: boolean
) {
    return Controller(
        ExportarDocumentoHtmlParaPdfServices(requestBody, FL_GERAR_PDF)
    );
}

export async function ListarContratosCasoController(ID_CASO: number) {
    return Controller(ListarContratosCasoServices(ID_CASO));
}

export async function ListarEnvelopesCasoController(ID_CASO: number) {
    return Controller(ListarEnvelopesCasoService(ID_CASO));
}

export async function BuscarInformacoesEnvelopeController(id_envelope: number) {
    return Controller(BuscarInformacoesEnvelopeService(id_envelope));
}
export async function DownloadEnvelopeController(
    ID_ENVELOPE: number,
    ID_TIPO_CASO: number
) {
    return Controller(DownloadEnvelopeService(ID_ENVELOPE, ID_TIPO_CASO));
}

export async function ReenviarEnvelopeController(ID_ENVELOPE: number) {
    return Controller(ReenviarEnvelopeService(ID_ENVELOPE));
}

export async function InserirEnvelopeDocusignController(
    requestBody: Partial<IInserirEnvelope>
) {
    return Controller(InserirEnvelopeDocusignService(requestBody));
}

export async function DesvincularContratosCasoController(
    ID_CASO_DOCUMENTO_GERADO: number,
    FL_EXCLUIR: boolean
) {
    return Controller(
        DesvincularContratosCasoService(ID_CASO_DOCUMENTO_GERADO, FL_EXCLUIR)
    );
}

export async function GerarDocumentosTemplateController(
    idDocumentoTemplate: number,
    idCaso: number
) {
    return Controller(
        GerarDocumentosTemplateServices(idDocumentoTemplate, idCaso)
    );
}

export async function ListarClienteEmailTriagemController(
    ID_USUARIO: number,
    idTipoCaso: number,
    requestBody: ITriagem
) {
    return Controller(
        ListarClienteEmailTriagemService(ID_USUARIO, idTipoCaso, requestBody)
    );
}

export async function ListarClienteRespostaEmailTriagemController(
    ID_EMAIL: number
) {
    return Controller(ListarClienteRespostaEmailTriagemService(ID_EMAIL));
}
